import React from "react";
import customer1 from "../assets/images/1.png";
import customer2 from "../assets/images/2.png";
import customer3 from "../assets/images/3.png";
import customer4 from "../assets/images/4.png";
import customer5 from "../assets/images/5.png";
import customer6 from "../assets/images/6.png";
import customer7 from "../assets/images/7.png";
import customer8 from "../assets/images/8.png";
import customer9 from "../assets/images/9.png";
import customer10 from "../assets/images/10.png";
import customer11 from "../assets/images/11.png";
import customer12 from "../assets/images/12.png";
import { Link } from "react-router-dom";

export default function Customers() {
	const customers = [
		{ id: 9, image: customer10, name: "AMATAX", link: "http://www.amatax.co.uk/" },
		{ id: 10, image: customer9, name: "KUPOD", link: "https://www.kupod.co.uk/" },
		{ id: 8, image: customer8, name: "YouLearnt", link: "https://youlearnt.com/" },
		{ id: 2, image: customer2, name: "idp" },
		{ id: 4, image: customer4, name: "ALFA SCIENTIFIC", link: "https://www.alfasci.com/" },
		{ id: 1, image: customer1, name: "micro", link: "https://micro-s.com/" },
		{ id: 3, image: customer3, name: "ARAB SCIENCE", link: "https://www.arab-science.com/" },
		{ id: 6, image: customer6, name: "Hala" },
		{ id: 7, image: customer7, name: "HEMEX" },
		{ id: 5, image: customer5, name: "READ&BREAD" },
		{ id: 11, image: customer11, name: "2BSystems", link: "http://www.2bsystems.us.com/" },
		{ id: 12, image: customer12, name: "Prototype", link: "https://www.instagram.com/prototype_qatar_2008?igsh=eXRpNTl4OXo3NmNy/" },
	];

	// Inline styles for the hover effect
	const linkStyle = {
		display: "inline-block",
		transition: "transform 0.3s ease, box-shadow 0.3s ease",
		textDecoration: "none",
	};

	const hoverStyle = {
		transform: "scale(1.1)",
		boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
	};

	return (
		<div style={{ padding: "2rem 0" }}>
			<h1 style={{ textAlign: "center", fontFamily: "sans-serif" }}>Trusted by</h1>

			{/* Container for customer logos */}
			<div
				style={{
					maxWidth: "1200px",
					margin: "0 auto",
					display: "flex",
					flexWrap: "wrap",
					justifyContent: "center",
				}}
			>
				{customers.map((customer) => (
					<Link
						key={customer.id}
						to={customer.link ? customer.link : "/"}
						target='_blank'
						style={{
							...linkStyle,
							width: "25%", // Default for desktop (4 items per row)
							padding: "1rem",
						}}
						className='customer-item' // Add a class for targeting in CSS
						onMouseEnter={(e) => {
							e.currentTarget.style.transform = hoverStyle.transform;
							e.currentTarget.style.boxShadow = hoverStyle.boxShadow;
						}}
						onMouseLeave={(e) => {
							e.currentTarget.style.transform = "scale(1)";
							e.currentTarget.style.boxShadow = "none";
						}}
					>
						<div style={{ textAlign: "center" }}>
							<img
								src={customer.image}
								alt={customer.name}
								className='customer-image' // Add a class for targeting in CSS
								style={{ maxWidth: "100%", height: "auto" }}
							/>
						</div>
					</Link>
				))}
			</div>

			{/* Mobile-specific styles */}
			<style>
				{`
					@media (max-width: 768px) {
						.customer-item {
						padding: 0 !important; /* Reduce padding */
							width: 33.33% !important; /* 3 items per row */
						}
						.customer-item:nth-child(n+10) {
							width: 33.33% !important; /* Last 2 items in the last row */
						}
 
					}
				`}
			</style>
		</div>
	);
}
